import { SET_LOADING, SET_DOCS, SET_ERROR } from "./types";

const Reducer = (state, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true
      };
    case SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case SET_DOCS:
      return {
        ...state,
        loading: false,
        docs: action.payload,
        types: [...new Set(action.payload.map(doc => doc.type))].sort(),
        categories: [
          ...new Set(
            [].concat(...[...new Set(action.payload.map(doc => doc.category))]).sort()
          )
        ].flat(),
        laos: [
          ...new Set(
            [].concat(...[...new Set(action.payload.map(doc => doc.lao))])
          )
        ].flat()
      };
    default:
      return state;
  }
};

export default Reducer;
